import './map.css';
import React, { Component } from 'react'
import { Map, TileLayer } from 'react-leaflet' // ★変更：TileLayer を追加
import WindDirectionArrow from '../track/wind-direction-arrow.svg';
import MainPlayer from './mainPlayer'
import FullscreenControl from 'react-leaflet-fullscreen';
//import { DriftMarker } from "leaflet-drift-marker"
import { isSailingLike } from '../../dispMode';



export default class MapBrowser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pos: this.props.pos,
      zoom: 15,
    }
  }


  render() {

    const { user } = this.props;
    const unit = user ? user.unit : "knot"

    const isSailing = isSailingLike(user && user.organization && user.organization.event);
    console.log("Event Name:", user?.organization?.event?.name, "isSailing:", isSailing);

    return (

      <div style={{ position: 'relative' }}>
        {/* ★風向きUIを絶対配置で表示 */}
        <div className="leaflet-top leaflet-right">
          <div className='leaflet-control wind-direction-icon' style={{ padding: 0 }}>
            <span className='top-label'>WIND</span>
            <span className='arrow-label'>
              <img
                alt={'Wind'}
                className='arrow-img'
                src={WindDirectionArrow}
                style={{ transform: `rotateZ(${this.props.windDirection}deg)` }}
              />
            </span>
            <span className='bottom-label'>{this.props.windSpeed}</span>
          </div>
        </div>

        <Map ref='map' center={this.props.center} zoom={this.state.zoom} doubleClickZoom={true} attributionControl={false} style={{ height: '40vh' }} maxZoom={22} >
          {/* ★変更：国土地理院 → Esri World Imagery (ArcGIS) TileLayer */}
          <TileLayer
            attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            maxZoom={22}
            maxNativeZoom={19}
          />

          {Object.keys(this.props.deviceMap).map(key => (
            <MainPlayer unit={unit} isSailing={isSailing} device={this.props.deviceMap[key]} />
          ))}

          <FullscreenControl position="topleft" forceSeparateButton={true} />
        </Map>
      </div>
    )
  }
}
